/**
 * Violation Mapper
 * Converts internal violation objects to user-friendly descriptions
 * NEVER shows cost to users - only clear rule violation descriptions
 */

/**
 * Convert internal violation to user-friendly description
 */
export function mapViolationToDescription(violation) {
  const descriptions = {
    'FAMILY_CONFLICT': {
      icon: '👨‍👩‍👧‍👦',
      title: 'Multiple Family Members',
      description: 'Buying for more than one person in the same family',
      severity: 'warning' // yellow
    },
    'RECIPROCAL_CONFLICT': {
      icon: '🔄',
      title: 'Reciprocal Gifting',
      description: 'Two people buying gifts for each other',
      severity: 'caution' // orange
    },
    'ADULT_DISTRIBUTION': {
      icon: '🎯',
      title: 'Adult Gift Rule',
      description: 'Adult not buying for at least one other adult',
      severity: 'important' // red
    }
  };

  return descriptions[violation.rule] || {
    icon: '⚠️',
    title: 'Rule Violation',
    description: 'Unknown constraint violation',
    severity: 'warning'
  };
}

/**
 * Group violations by type for display
 */
export function groupViolations(violations) {
  const grouped = {
    family: [],
    ownFamily: [],      // NEW: Critical same-family violations
    reciprocal: [],
    adult: []
  };

  violations.forEach(v => {
    // Map both old and new violation types
    if (v.rule === 'FAMILY_CONFLICT' || v.rule === 'multiFamily') {
      grouped.family.push(v);
    } else if (v.rule === 'ownFamily') {
      // CRITICAL: Same family member violations (deal breaker!)
      grouped.ownFamily.push(v);
    } else if (v.rule === 'RECIPROCAL_CONFLICT' || v.rule === 'reciprocal') {
      grouped.reciprocal.push(v);
    } else if (v.rule === 'ADULT_DISTRIBUTION' || v.rule === 'adultMandate') {
      grouped.adult.push(v);
    }
  });

  return grouped;
}

/**
 * Get severity color classes for UI
 */
export function getSeverityClasses(severity) {
  const classes = {
    'warning': {
      bg: 'bg-yellow-100',
      border: 'border-yellow-300',
      text: 'text-yellow-900',
      lightBg: 'bg-yellow-50'
    },
    'caution': {
      bg: 'bg-orange-100',
      border: 'border-orange-300',
      text: 'text-orange-900',
      lightBg: 'bg-orange-50'
    },
    'important': {
      bg: 'bg-red-100',
      border: 'border-red-300',
      text: 'text-red-900',
      lightBg: 'bg-red-50'
    }
  };

  return classes[severity] || classes['warning'];
}
